module.exports = __webpack_public_path__ + "static/media/practice-shade1.d79d167b.svg";